<template>
  <div class="main">
    <div class="container">
      <div class="header">
        <router-link :to="{name: 'home'}">
          <el-button type="primary" class="back-button" icon="el-icon-back"></el-button>
        </router-link>
        <el-button type="primary" @click="centerDialogVisible = true" class="users-button">
          <font-awesome-icon icon="users" />
        </el-button>
      </div>
      <div class="content">
        <h2>Wichtelgruppe beitreten - {{project.name}}</h2>
        <span>Um an der Wichtelgruppe '{{project.name}}' teilzunehmen, benötigen wir deinen Namen und eine E-Mail Adresse.</span>
        <span>Der Admin hat später keine Möglichkeit die zugeteilen Wichtel einzusehen!</span>
        <span class="input-label">Vorname</span>
        <el-input v-model="user.firstname" placeholder="Vorname"></el-input>

        <span class="input-label">Nachname</span>
        <el-input v-model="user.lastname" placeholder="Nachname"></el-input>

        <span class="input-label">E-Mail</span>
        <el-input type="email" v-model="user.email" placeholder="E-Mail"></el-input>

        <el-button type="primary" v-on:click="joinProject" class="create-button" round>Wichtelgruppe beitreten</el-button>
      </div>
    </div>
    <el-dialog title="Benutzer in der Gruppe" :visible.sync="centerDialogVisible" center>
      <div class="grid">
        <el-card v-for="(user, index) in this.project.users" :key="index">
          <div class="user-card">
            <div class="content">
              <span>{{user.firstname}} {{user.lastname}}</span><br>
            </div>
          </div>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ProjectService from "../services/ProjectService.js";
import ErrorService from "../services/ErrorService.js";

export default {
  name: "JoinProject",
  data() {
    return {
      project: {
        name: "",
        max_users: 0,
        email: ""
      },
      user: {
        firstname: "",
        lastname: "",
        email: "",
        project: null
      },
      centerDialogVisible: false
    };
  },
  created() {
    ProjectService.getProjectById(this.$route.params.id).then(project => {
      this.project = project;
      this.user.project = project.id;
    });
  },
  methods: {
    joinProject() {
      ProjectService.addUserToProject(this.user, this.project)
        .then(result => {
          this.project = result;
          ProjectService.addProjectToLocalStorage(this.project.encryptedKey, 'user');
          this.$notify({
            title: "Erfolgreich",
            message: `Du hast die Gruppe erfolgreich betreten. Sobald alle Benutzer die Gruppe betreten haben, 
                wird eine Mail an die einzelnen Benutzer mit ihrem Wichtelpartner gesendet.`,
            duration: 0,
            type: "success"
          });
          this.user = {
            firstname: "",
            lastname: "",
            email: "",
            project: null
          };
        })
        .catch(response => {
          this.$notify.error({
            title: "Fehler",
            message: ErrorService.getErrorMsg(response.error)
          });
        });
    },
    showUsers() {}
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.input-label {
  margin-top: 20px;
}

.create-button {
  margin-top: 25px;
  min-height: 40px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: 20px;
  align-items: stretch;
  width: 100%;

  .user-card {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
  }

  button {
    font-size: 8px;
  }

  .bottom {
    display: flex;
    justify-content: space-around;
    margin-top: 15px;
  }
}
.grid > .el-card {
  border: 1px solid #ccc;
  box-shadow: 2px 2px 6px 0px rgba(0, 0, 0, 0.4);

  span.small {
    font-size: 12px;
  }
}

/deep/ .el-card__body {
  height: 75%;
}
</style>
